import { User } from "lucide-react";
import { Link } from "react-router-dom";

import { useLogout } from "@/api/logout";
import { Button } from "@/components/ui/button";

import { OnboardingHeader } from "./onboarding-header";

export function SwitchAccountToAcceptInvitation() {
  const { mutateAsync: logout, isPending: isLogoutPending } = useLogout();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <>
      <OnboardingHeader
        title="Switch Account to Accept Invitation"
        description="You're logged in with a different email. To accept the invitation, you need to log out and switch accounts."
        Icon={User}
        className="mb-6"
      />

      <div className="flex gap-2">
        <Button
          type="button"
          disabled={isLogoutPending}
          isLoading={isLogoutPending}
          onClick={handleLogout}
          isAnimated
        >
          Accept Invitation
        </Button>
        <Button variant="outline" asChild>
          <Link to="/">Stay Logged In</Link>
        </Button>
      </div>
    </>
  );
}
